import { useDroppable } from '@dnd-kit/core'
import { SortableContext } from '@dnd-kit/sortable'
import { MdEdit, MdDelete } from 'react-icons/md'
import { TaskCard } from './TaskCard'
import { Column, Task } from './types'

type KanbanColumnProps = {
  column: Column
  tasks: Task[]
  companyMap: Record<number, string>
  onAddTask: (columnId: string) => void
  onEditTask: (task: Task) => void
  onDeleteTask: (taskId: string) => void
  onEditColumn: (column: Column) => void
  onDeleteColumn: (columnId: string) => void
}

export const KanbanColumn = ({
  column,
  tasks,
  companyMap,
  onAddTask,
  onEditTask,
  onDeleteTask,
  onEditColumn,
  onDeleteColumn
}: KanbanColumnProps) => {
  const { setNodeRef } = useDroppable({
    id: column.id,
    data: { type: 'Column', columnId: column.id }
  })

  return (
    <div className="group/col flex w-72 flex-shrink-0 flex-col rounded-xl bg-[#e8f5f3] shadow-sm">
      <div className="flex items-center justify-between rounded-t-xl px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-gray-700">{column.title}</span>
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#01695C] text-xs font-bold text-white">
            {tasks.length}
          </span>
        </div>
        <div className="flex gap-1 opacity-0 transition-opacity group-hover/col:opacity-100">
          <button
            type="button"
            onClick={() => onEditColumn(column)}
            className="rounded p-1 text-[#01695C] hover:bg-[#b8ddd9] hover:text-[#01695C]"
            title="カラム名を編集"
          >
            <MdEdit size={18} />
          </button>
          <button
            type="button"
            onClick={() => onDeleteColumn(column.id)}
            className="rounded p-1 text-[#01695C] hover:bg-[#b8ddd9] hover:text-red-500"
            title="カラムを削除"
          >
            <MdDelete size={18} />
          </button>
        </div>
      </div>

      <div
        ref={setNodeRef}
        className="flex flex-1 flex-col gap-2 overflow-y-auto px-3 pb-3"
        style={{ maxHeight: 'calc(100vh - 260px)' }}
      >
        <SortableContext items={tasks.map((task) => task.id)}>
          {tasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              companyMap={companyMap}
              onEdit={onEditTask}
              onDelete={onDeleteTask}
            />
          ))}
        </SortableContext>
      </div>

      <button
        type="button"
        onClick={() => onAddTask(column.id)}
        className="m-3 mt-0 rounded-lg border-2 border-dashed border-gray-300 py-2 text-sm text-gray-500 hover:border-[#01695C] hover:text-[#01695C]"
      >
        ＋ タスクを追加
      </button>
    </div>
  )
}
